var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSport43A0(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Dribbble",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24,0V24H0V0Z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4789",
    "data-name": "Group 4789",
    transform: "translate(0.423 0.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M8.537,5.358A45.117,45.117,0,0,0,5.232,0,9.777,9.777,0,0,0,0,6.586a19.377,19.377,0,0,0,7.734-.929C8.009,5.565,8.273,5.461,8.537,5.358Z",
    transform: "translate(2.077 2.822)",
    fill: "rgba(0,236,102,0.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M10.487,2.088a4.183,4.183,0,0,0-.161-.4C10.086,1.113,9.822.551,9.558,0c-.333.126-.665.264-1.021.39a21.6,21.6,0,0,1-6.793,1.1C1.17,1.492.6,1.457.023,1.411.011,1.56,0,1.7,0,1.847a9.769,9.769,0,0,0,2,5.9,18.021,18.021,0,0,1,5.37-4.406A18.272,18.272,0,0,1,10.487,2.088Z",
    transform: "translate(1.824 9.73)",
    fill: "rgba(0,236,102,0.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M2.616,0A9.867,9.867,0,0,0,0,.367a48.091,48.091,0,0,1,3.236,5.3A20.122,20.122,0,0,0,8.445,1.951,9.729,9.729,0,0,0,2.616,0Z",
    transform: "translate(8.962 1.824)",
    fill: "rgba(0,236,102,0.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,5.278A9.676,9.676,0,0,0,6.6,7.871,9.65,9.65,0,0,0,9.96,7.263,45,45,0,0,0,7.975,0,16.04,16.04,0,0,0,5,1.136,16.2,16.2,0,0,0,0,5.278Z",
    transform: "translate(4.98 13.458)",
    fill: "#00ec66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M1.893,7.14A9.766,9.766,0,0,0,6.54.393,17.536,17.536,0,0,0,0,.233,44.9,44.9,0,0,1,1.893,7.14Z",
    transform: "translate(14.641 12.824)",
    fill: "#00ec66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M.792,5.817c.092.229.172.459.264.688a19.256,19.256,0,0,1,7.321.057A9.693,9.693,0,0,0,5.726,0,21.556,21.556,0,0,1,0,4.108C.275,4.681.539,5.243.792,5.817Z",
    transform: "translate(12.953 4.922)",
    fill: "rgba(0,236,102,0.4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSport43A0);
export default __webpack_public_path__ + "static/media/sport43a0.d6c120711bf44e38ac87ad248b7c71ed.svg";
export { ForwardRef as ReactComponent };